import React, { Component } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
} from "reactstrap";
import { withRouter, Link } from "react-router-dom";
 
//i18n
import { withTranslation } from "react-i18next";
 
// users
// import user1 from "../../../assets/images/users/avatar-1.jpg";
import user1 from "../../../assets/images/brands/avatar1.png";
 
import { connect } from "react-redux";
import { decryptData } from "helpers/crypto_helper";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
 
const getUserName = () => {
  if (localStorage.getItem("authUser")) {
    const obj = JSON.stringify(localStorage.getItem("authUser"))
    const data = JSON.parse(obj)
    const DecryptData = decryptData(data)
    return JSON.parse(DecryptData);
  }
}
 
class ProfileMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: false,
      name: "",
      profileImage: "",
      showLogoutModal: false,
    }
    this.toggle = this.toggle.bind(this)
  }
 
  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu,
    }))
  }
 
  componentDidMount() {
    const userData = getUserName();
    const authUserDetails = useAuthUserDetails();
    const profile_image = authUserDetails[0]?.profile_image;
    const empName = authUserDetails[0]?.emp_title;
    if (authUserDetails) {
      this.setState({
        name: empName,
        profileImage: profile_image,
      });
    }
  }
 
  componentDidUpdate(prevProps) {
    if (prevProps.success !== this.props.success) {
      const userData = getUserName();
      const authUserDetails = useAuthUserDetails();
      const profile_image = authUserDetails[0]?.profile_image;
      const empName = authUserDetails[0]?.emp_title;
      if (authUserDetails) {
        this.setState({
          name: empName,
          profileImage: profile_image,
        });
      }
    }
  }
 
  handleLogoutClick = (e) => {
    e.preventDefault();
    this.setState({ showLogoutModal: true });
  }
 
  handleLogoutConfirm = () => {
    this.setState({ showLogoutModal: false }, () => {
      this.props.history.push("/logout");
    });
  }
 
  handleLogoutCancel = () => {
    this.setState({ showLogoutModal: false });
  }
 
  render() {
    const { profileImage, showLogoutModal } = this.state;
    return (
      <React.Fragment>
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="d-inline-block"
        >
          <DropdownToggle
            className="btn header-item"
            id="page-header-user-dropdown"
            tag="button"
          >
            <img
              className="rounded-circle header-profile-user"
              // src={user1}
              src={profileImage ? profileImage : user1}
              alt="Header Avatar"
            />{" "}
            <span className="d-none d-xl-inline-block ms-1">
              {this.state.name}
            </span>
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem tag="a" href="/my-profile">
              <i className="bx bx-user font-size-16 align-middle ms-1" />
              {this.props.t("Profile")}
            </DropdownItem>
            {/* <DropdownItem tag="a" href="/my-attendance">
              <i className="bx bx-calendar font-size-16 align-middle ms-1" />
              {this.props.t("Calendar")}
            </DropdownItem> */}
            {/* <DropdownItem tag="a" href="#">
              <i className="bx bx-wrench font-size-17 align-middle me-1" />
              {this.props.t("Settings")}
            </DropdownItem> */}
            <div className="dropdown-divider" />
            <a href="/logout" className="dropdown-item" onClick={this.handleLogoutClick}>
              <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
              <span>{this.props.t("Logout")}</span>
            </a>
          </DropdownMenu>
        </Dropdown>
 
        {/* Logout Confirmation Modal */}
        {/* <Modal isOpen={showLogoutModal} toggle={this.handleLogoutCancel} centered>
          <div className="modal-header border-bottom-0">
            <button
              type="button"
              className="btn-close"
              onClick={this.handleLogoutCancel}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body text-center">
            <h5 className="mb-3">{this.props.t("Are you sure you want to log out?")}</h5>
            <div className="d-flex justify-content-center gap-2">
              <button className="btn btn-danger" onClick={this.handleLogoutConfirm}>{this.props.t("Yes")}</button>
              <button className="btn btn-secondary" onClick={this.handleLogoutCancel}>{this.props.t("No")}</button>
            </div>
          </div>
        </Modal> */}
        {/* Logout Confirmation Modal */}
        <Modal isOpen={showLogoutModal} toggle={this.handleLogoutCancel} centered>
          <div className="modal-body text-center p-4">

            {/* Icon */}
            <div className="mb-3">
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  border: "2px solid #f59e0b",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto",
                  color: "#f59e0b",
                  fontSize: "28px",
                  fontWeight: "700"
                }}
              >
                !
              </div>
            </div>

            {/* Title */}
            <h4 className="mb-2">
              Are you sure?
            </h4>

            {/* Message */}
            <p className="text-muted mb-4">
              You are about to log out of the system.
            </p>

            {/* Buttons */}
            <div className="d-flex justify-content-center gap-2">
              <button
                className="btn btn-primary"
                onClick={this.handleLogoutConfirm}
              >
                Confirm
              </button>

              <button
                className="btn btn-secondary"
                onClick={this.handleLogoutCancel}
              >
                Cancel
              </button>
            </div>

          </div>
        </Modal>
      </React.Fragment>
    )
  }
}
 
ProfileMenu.propTypes = {
  t: PropTypes.any,
  success: PropTypes.string
}
 
const mapStateToProps = state => {
  const { success } = state.Profile
  return { success }
}
 
export default withRouter(
  connect(mapStateToProps, {})(withTranslation()(ProfileMenu))
)